var $passengerTypesTDs = null;

$(document).ready(function(){
	$passengerTypesTDs = $(".pType[type]");
});

var providerDefMap = new Object();

function setProvidersPassengers(providerId, flightdeparture, flightarrival, faretype){

	var isShown=false;

	/*if(providerDefMap == null || providerDefMap[providerId] == null){*/
		$.ajax({
			type : "POST",
			async: false,
			url : "/getProviderRestriction",
			dataType : "json",
			data : {
				fromAirportId : flightdeparture,
				toAirportId : flightarrival,
				providerId : providerId, 
				fareType : faretype
			},
			success: function(data) {
				providerDefMap[data.providerId] = data;
			}
		});
	/*}*/

	/**
	//for general case,	Adult/Child/Infant
	$passengerTypesTDs.filter("[type=adult]").show();
	$passengerTypesTDs.filter("[type=adult]:first").find("select>option:eq(1)").attr("selected","selected");
	$passengerTypesTDs.filter("[type=child]").show();
	$passengerTypesTDs.filter("[type=infant]").show();

	$(".discountAdultType").hide();
	$passengerTypesTDs.filter("[type=child]:first").find("select>option:eq(0)").attr("selected","selected");
	$passengerTypesTDs.filter("[type=infant]:first").find("select>option:eq(0)").attr("selected","selected");
	resetProvidersPassengers();
	
	if(providerDefMap == null || providerDefMap[providerId] == null)
		return isShown;
	

	if (providerDefMap[providerId].senior) {
		$("#passenger_desc_SENIOR").html(providerDefMap[providerId].seniorDescription);
		$passengerTypesTDs.filter("[type=senior]").show();
		$(".discountAdultType").show();
		isShown = true;
	}
	if (providerDefMap[providerId].student) {
		$("#passenger_desc_STUDENT").html(providerDefMap[providerId].studentDescription);
		$passengerTypesTDs.filter("[type=student]").show();
		$(".discountAdultType").show();
		isShown = true;
	}
	if (providerDefMap[providerId].military) {
		$("#passenger_desc_MILITARY").html(providerDefMap[providerId].militaryDescription);
		$passengerTypesTDs.filter("[type=military]").show();
		$(".discountAdultType").show();
		isShown = true;
	}
	if (providerDefMap[providerId].young) {
		$("#passenger_desc_YOUNG").html(providerDefMap[providerId].youngDescription);
		$passengerTypesTDs.filter("[type=young]").show();
		$(".discountAdultType").show();
		isShown = true;
	}
	*/
	return isShown;
}

function resetProvidersPassengers(){
	$passengerTypesTDs.filter("[type=student]").hide();
	$passengerTypesTDs.filter("[type=military]").hide();
	$passengerTypesTDs.filter("[type=senior]").hide();
	$passengerTypesTDs.filter("[type=young]").hide();
	
	$passengerTypesTDs.filter("[type=student]:first").find("select>option:eq(0)").attr("selected","selected");
	$passengerTypesTDs.filter("[type=military]:first").find("select>option:eq(0)").attr("selected","selected");
	$passengerTypesTDs.filter("[type=senior]:first").find("select>option:eq(0)").attr("selected","selected");
	$passengerTypesTDs.filter("[type=young]:first").find("select>option:eq(0)").attr("selected","selected");
}
